export const state = {
  jobcards: [],
  systemJobcard: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/jobcards/state.js